import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';
import { EdsEntityCodes } from '@/features/eds/enums/EdsEntityCodes';
import { deleteBenefitAdjustment, deletePaymentAdjustment } from '@/domains/adjustments/store/deleteAdjustment.slice';
import { getBenefitSectionDetails } from '@/domains/claims/features/ClaimSetClaimList/store/claimSetClaimList';
import { getPayments } from '@/domains/payments/features/PaymentsSection/store/payments.slice';
import HttpService from '@/services/HttpService/HttpService';

function* deletePaymentAdjustmentSaga({
  payload: { adjustmentId, claimId },
}: PayloadAction<{ claimId: string | number; adjustmentId: string | number }>) {
  try {
    yield call(HttpService.delete, `/${EdsEntityCodes.PaymentAdjustment}/delete-adjustment/${adjustmentId}`);

    yield put(getPayments({ claimId: Number(claimId) }));
  } catch (error) {
    console.error(error);
  }
}

function* deleteBenefitAdjustmentSaga({
  payload: { adjustmentId, claimId },
}: PayloadAction<{ claimId: string | number; adjustmentId: string | number }>) {
  try {
    yield call(HttpService.delete, `/examiner/benefit-adjustment/${adjustmentId}`, {
      baseURL: import.meta.env.VITE_API_URL_V2,
    });

    yield put(getBenefitSectionDetails(`${claimId}`));
  } catch (error) {
    console.error(error);
  }
}

export function* deleteAdjustmentWatcher() {
  yield takeLatest([deletePaymentAdjustment.type], deletePaymentAdjustmentSaga);
  yield takeLatest([deleteBenefitAdjustment.type], deleteBenefitAdjustmentSaga);
}
